export default {
  labels: {
    page: 'Página {{current}} de {{total}}',
    no_file_specified: 'Nenhum ficheiro foi especificado',
  },
  buttons: {
    previous: 'Anterior',
    next: 'Seguinte',
  },
};
